import { Box, Stack, Typography } from "@mui/material";
import React from "react";
function toDateTime(secs) {
  var t = new Date(1970, 0, 1); // Epoch
  t.setSeconds(secs);
  return t;
}
function SiteListRow({ data, onClick, onDelete, ...props }) {
  console.log(data);
  let { clientName, timeDateCreated, name } = data;

  // convert timeDateCreated to a string of YYYY-MM-DD

  const date = toDateTime(timeDateCreated.seconds);
  timeDateCreated = date.toLocaleDateString();

  timeDateCreated = timeDateCreated.replaceAll("/", "-");

  return (
    <Box
      {...props}
      onClick={() => {
        onClick(data);
      }}
    >
      <Stack direction={"row"} spacing={3}>
        <Typography width="15rem" alignSelf={"center"}>
          {clientName}
        </Typography>
        <Typography width="15rem" alignSelf={"center"}>
          {name}
        </Typography>
        <Typography width="15rem" alignSelf={"center"}>
          {timeDateCreated}
        </Typography>
      </Stack>
    </Box>
  );
}

export default SiteListRow;
